module.exports = __webpack_public_path__ + "img/96.f29403b6.jpg";